import * as yup from "yup";

/**
 * Shared validation schema for login forms
 * Used by both Studio and Artist login
 */
export const loginSchema = yup.object().shape({
    name: yup.string().required(),
    password: yup.string().required(),
});

